import { useEffect, type RefObject } from 'react';

/**
 * Clicking outside a modal <dialog>'s content closes it. Browsers with `closedby="any"` (light
 * dismiss) do this themselves and fire the dialog's cancel event; for the others, a click on the
 * dialog's own box (the backdrop area around its content) asks it to cancel the same way.
 */
export function useLightDismiss(ref: RefObject<HTMLDialogElement | null>, active: boolean) {
  useEffect(() => {
    const d = ref.current;
    if (!d || !active || 'closedBy' in HTMLDialogElement.prototype) return;
    const onDown = (e: MouseEvent) => {
      if (e.target === d) d.dispatchEvent(new Event('cancel', { cancelable: true }));
    };
    d.addEventListener('mousedown', onDown);
    return () => d.removeEventListener('mousedown', onDown);
  }, [ref, active]);
}
